import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TechnicalViewService } from 'src/app/_services/technical-view.service';
import { VehiclesService } from 'src/app/_services/vehicles.service';
import { IssuesService } from 'src/app/_services/issues.service';

@Component({
  selector: 'app-view-technical',
  templateUrl: './view-technical.component.html',
  styleUrls: ['./view-technical.component.scss'],
})
export class ViewTechnicalComponent implements OnInit {
  signOffData: any;
  technicalRecordData: any;
  vehicleData: any;

  constructor(
    private config: DynamicDialogConfig,
    private vehiclesService: VehiclesService,
    private technicalViewService: TechnicalViewService,
    private issuesService: IssuesService
  ) {}

  ngOnInit(): void {
    this.technicalRecordData = this.config.data.technicalRecord;
    this.vehicleData = this.config.data.vehicleData;
    // console.log('technicalRecordData', this.technicalRecordData);
    // console.log('vehicleData', this.vehicleData);
    // this.issuesService
    //   .getActiveIssueByVehicleId(this.vehicleData.id)
    //   .subscribe((data: any) => {
    //     // console.log('active issue data', data);
    //   });
  }

  signOffDataOutput(data: any) {
    this.signOffData = data;
  }
}
